export default "__VITE_ASSET___Te8P7jR__"